import React, { useEffect, useState } from 'react';
import { Col, Container, DropdownButton, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import '../../../../styles/Forms.css';

export function POCSection(props) {
    const [account] = useState(props.account)
    const [member] = useState(props.member)
    const [pocs, setPocs] = useState([]);
    const [pocType, setPocType] = useState(props.member.pocTypeName)

    useEffect(() => {
        props.member.pocTypeName = pocType;

        if (pocType && pocType !== "") {
            props.setPocOkay();
        }
        else {
            props.setPocNotOkay();
        }
    }, [pocType])

    useEffect(() => {
        if (account) {
            var initialAcctPocs = account.poCs;
            var acctPocs = [];
            initialAcctPocs.forEach((poc) => {
                var inList = false;
                acctPocs.forEach((acctPoc) => {
                    if (!poc.id || poc.id === "") {
                        inList = false;
                    }
                    else if (poc.id === acctPoc.id) {
                        inList = true;
                    }
                })
                if (!inList) {
                    acctPocs.push(poc);
                }
            })
            setPocs(acctPocs);
        }
    },[account])

    const checkEnabledPOCPosition = (position, type) => {
        var okay = true;

        if (account && pocs) {
            var memberPocType = "";
            if (member.pocTypeName) {
                memberPocType = member.pocTypeName;
            }
            for (var i = 0; i < pocs.length; i++) {
                var poc = pocs[i];
                var pocTypeName = "";
                if (poc.pocTypeName) {
                    pocTypeName = poc.pocTypeName;
                }

                switch (position) {
                    case "Primary":
                        if (!memberPocType.includes("Primary Point")
                            && pocTypeName.includes("Primary Point")) {
                            okay = false;
                        }
                        if (type === "CHR" &&
                            !memberPocType.includes("Primary CHR")&&
                            pocTypeName.includes("Primary CHR")) {
                            okay = false;
                        }
                        else if (type === "Notify" &&
                            !memberPocType.includes("Primary Notify")&&
                            pocTypeName.includes("Primary Notify")) {
                            okay = false;
                        }
                        else if (type === "Both" &&
                            !memberPocType.includes("Primary Point")
                            && ((!memberPocType.includes("Primary CHR") &&
                                pocTypeName.includes("Primary CHR")) ||
                                (!memberPocType.includes("Primary Notify") &&
                                    pocTypeName.includes("Primary Notify")))) {
                            okay = false;
                        }
                        break;
                    case "Secondary":
                        if (!memberPocType.includes("Secondary Point")
                            && pocTypeName.includes("Secondary Point")) {
                            okay = false;
                        }
                        if (type === "CHR" &&
                            !memberPocType.includes("Secondary CHR") &&
                            pocTypeName.includes("Secondary CHR")) {
                            okay = false;
                        }
                        else if (type === "Notify" &&
                            !memberPocType.includes("Secondary Notify") &&
                            pocTypeName.includes("Secondary Notify")) {
                            okay = false;
                        }
                        else if (type === "Both" &&
                            !memberPocType.includes("Secondary Point")
                            && ((!memberPocType.includes("Secondary CHR") &&
                                pocTypeName.includes("Secondary CHR")) ||
                            (!memberPocType.includes("Secondary Notify") &&
                                pocTypeName.includes("Secondary Notify")))) {
                            okay = false;
                        }
                        break;
                    case "Tertiary":
                        if (!memberPocType.includes("Tertiary Point")
                            && pocTypeName.includes("Tertiary Point")) {
                            okay = false;
                        }
                        if (type === "CHR" &&
                            !memberPocType.includes("Tertiary CHR") &&
                            pocTypeName.includes("Tertiary CHR")) {
                            okay = false;
                        }
                        else if (type === "Notify" &&
                            !memberPocType.includes("Tertiary Notify") &&
                            pocTypeName.includes("Tertiary Notify")) {
                            okay = false;
                        }
                        else if (type === "Both" &&
                            !memberPocType.includes("Tertiary Point")
                            && ((!memberPocType.includes("Tertiary CHR") &&
                                pocTypeName.includes("Tertiary CHR")) ||
                                (!memberPocType.includes("Tertiary Notify") &&
                                    pocTypeName.includes("Tertiary Notify")))) {
                            okay = false;
                        }
                        break;
                    default: okay = false;
                        break;
                }
            }
        }
        return okay;
    }

    return (
        <Container>
            <Row style={{ padding: "4px" }}>
                <Col className="d-flex justify-content-start" style={{ padding: "4px" }}>
                </Col>
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="legal-name-tip">Please specify only one Point of Contact per position per service</Tooltip>}
                >
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>Point of Contact Position</div>
                        <DropdownButton
                            variant={(!pocType || pocType === "") ? "outline-danger" : "light"}
                            id={"poc-for-service"}
                            title={(pocType && pocType !== "") ? pocType : "Point of Contact Position"}
                        >
                            <DropdownItem onClick={() => { setPocType("") }}>--</DropdownItem>
                            {props.chrAllowed ?
                                <>
                                    <DropdownItem style={{ color: "#575757", textAlign: "center", border:"1px dotted gray" }} disabled>Community Health Record Point of Contact</DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Primary CHR Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Primary", "CHR")}>
                                        Primary
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Secondary CHR Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Secondary", "CHR")}>
                                        Secondary
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Tertiary CHR Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Tertiary", "CHR")}>
                                        Tertiary
                                    </DropdownItem>
                                </>
                                : <></>
                            }
                            {props.notifyAllowed ?
                                <>
                                    <DropdownItem style={{ color: "#575757", textAlign: "center", border: "1px dotted gray" }} disabled>Notify Point of Contact</DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Primary Notify Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Primary", "Notify")}>
                                        Primary
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Secondary Notify Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Secondary", "Notify")}>
                                        Secondary
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Tertiary Notify Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Tertiary", "Notify")}>
                                        Tertiary
                                    </DropdownItem>
                                </>
                                : <></>
                            }
                            {((props.chrAllowed && props.notifyAllowed) || (!props.chrAllowed && !props.notifyAllowed)) ?
                                <>
                                    {
                                        (!props.chrAllowed && !props.notifyAllowed) ?
                                            <DropdownItem style={{ color: "#575757", textAlign: "center", border: "1px dotted gray" }} disabled>Point of Contact</DropdownItem>
                                            :
                                            <>
                                                <DropdownItem style={{ color: "#575757", textAlign: "center", border: "1px dotted gray" }} disabled>CHR and Notify Point of Contact</DropdownItem>
                                            </>
                                    }
                                    <DropdownItem
                                        onClick={() => { setPocType("Primary Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Primary", "Both")}>
                                        Primary
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Secondary Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Secondary", "Both")}>
                                        Secondary
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => { setPocType("Tertiary Point of Contact") }}
                                        disabled={!checkEnabledPOCPosition("Tertiary", "Both")}>
                                        Tertiary
                                    </DropdownItem>
                                </>
                                : <></>
                            }
                            {account.ignorePOCLimit &&
                                <>
                                <DropdownItem style={{ color: "#575757", textAlign: "center", border: "1px dotted gray" }} disabled>--</DropdownItem>
                                <DropdownItem onClick={() => { setPocType("Other") }}>Other</DropdownItem>
                                </>
                            }
                        </DropdownButton>
                    </Col>
                </OverlayTrigger>
            </Row>
        </Container>
    );
}